import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export function NotFoundPagina() {
  const { t } = useTranslation();
  return (
    <div className="min-h-[60vh] grid place-items-center">
      <div className="text-center max-w-md">
        <div className="text-[72px] font-bold text-muted-foreground/40 leading-none">
          404
        </div>
        <h1 className="text-[20px] font-semibold mt-2">
          {t("algemeen.pagina_niet_gevonden")}
        </h1>
        <p className="text-[14px] text-muted-foreground mt-1">
          {t("algemeen.pagina_niet_gevonden_uitleg")}
        </p>
        <Button asChild className="mt-6">
          <Link to="/">{t("algemeen.naar_dashboard")}</Link>
        </Button>
      </div>
    </div>
  );
}
